"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppColorScheme = exports.EmbeddedIntersitialVideoAds = exports.EmbeddedIrsAction = exports.EMBEDDED_IRS_SOURCE = exports.EmbeddedAdAction = void 0;
var EmbeddedAdAction;
(function (EmbeddedAdAction) {
    EmbeddedAdAction["uccContinueUpgradeFlow"] = "uccContinueUpgradeFlow";
    EmbeddedAdAction["uccSkipUpgradeFlow"] = "uccSkipUpgradeFlow";
    EmbeddedAdAction["uccGoBackUpgradeFlow"] = "uccGoBackUpgradeFlow";
    EmbeddedAdAction["contentHeightChanged"] = "contentHeightChanged";
    EmbeddedAdAction["displayContentInModal"] = "displayContentInModal";
    EmbeddedAdAction["openUrl"] = "openUrl";
    EmbeddedAdAction["goBack"] = "goBack";
    EmbeddedAdAction["continueApplicationInFullScreen"] = "continueApplicationInFullScreen";
    EmbeddedAdAction["passToParent"] = "passToParent";
    EmbeddedAdAction["genericMoapVideoInterstitialClickContinue"] = "genericMoapVideoInterstitialClickContinue";
    EmbeddedAdAction["genericMoapVideoInterstitialClickGoBack"] = "genericMoapVideoInterstitialClickGoBack";
    EmbeddedAdAction["showFootnote"] = "showFootnote";
})(EmbeddedAdAction || (exports.EmbeddedAdAction = EmbeddedAdAction = {}));
exports.EMBEDDED_IRS_SOURCE = '__EMBEDDED_IRS__';
var EmbeddedIrsAction;
(function (EmbeddedIrsAction) {
    EmbeddedIrsAction["continue"] = "continue";
    EmbeddedIrsAction["displayContentInModal"] = "displayContentInModal";
    EmbeddedIrsAction["openSsnForm"] = "openSsnForm";
    EmbeddedIrsAction["openDocumentWithSsn"] = "openDocumentWithSsn";
})(EmbeddedIrsAction || (exports.EmbeddedIrsAction = EmbeddedIrsAction = {}));
var EmbeddedIntersitialVideoAds;
(function (EmbeddedIntersitialVideoAds) {
    EmbeddedIntersitialVideoAds["burkeMoap"] = "burke_moap";
    EmbeddedIntersitialVideoAds["burkeMoap20250707"] = "burke_moap_20250707";
})(EmbeddedIntersitialVideoAds || (exports.EmbeddedIntersitialVideoAds = EmbeddedIntersitialVideoAds = {}));
var AppColorScheme;
(function (AppColorScheme) {
    AppColorScheme["dark"] = "dark";
    AppColorScheme["light"] = "light";
})(AppColorScheme || (exports.AppColorScheme = AppColorScheme = {}));
